import { useEffect } from "react";

/* ============================================================
   VikiLoader — installazione UNICA, aggiornamenti AUTOMATICI
   Questo mini-caricatore scarica il widget VIKI direttamente dal
   portale AREAPAQ a ogni caricamento di pagina: quando VIKI viene
   aggiornata sul portale, questa app riceve la nuova versione da sola,
   senza pacchetti e senza deploy.
   Richiede nel .env del frontend (gia presente per l'SSO):
     REACT_APP_AREAPAQ_URL=https://www.areapaq.it
   ============================================================ */

const AREAPAQ_URL = (process.env.REACT_APP_AREAPAQ_URL || "https://www.areapaq.it")
  .replace(/\/+$/, "")
  .replace(/^https?:\/\/areapaq\.it$/i, "https://www.areapaq.it");

export default function VikiLoader() {
  useEffect(() => {
    if (window.__VIKI_LOADER__) return;
    window.__VIKI_LOADER__ = true;
    window.__VIKI_WIDGET_CONFIG__ = { url: AREAPAQ_URL, appKey: "risorice", appLabel: "Risorice" };
    fetch(`${AREAPAQ_URL}/api/viki/widget-version`)
      .then((r) => r.json())
      .catch(() => ({ version: Date.now() }))
      .then(({ version }) => {
        const s = document.createElement("script");
        s.src = `${AREAPAQ_URL}/viki-widget.js?v=${version}`;
        s.async = true;
        document.body.appendChild(s);
      });
  }, []);
  return null;
}
